// extracted by mini-css-extract-plugin
export default {"AwesomeListMenu":"AwesomeListMenu_AwesomeListMenu__uSh39"};